export interface IconProps {
  size?: number;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
}

const SearchIcon = ({
  size = 24,
  stroke = 'currentColor',
  strokeWidth = 3,
  className,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="m21 21-4.34-4.34" />
    <circle cx="11" cy="11" r="8" />
  </svg>
);

export default SearchIcon;
